/* Keep Alia from interrupting a shopper before they have had time to see the
   mobile hero. Alia continues to own targeting, frequency caps, and content. */
(() => {
  'use strict';

  if (!document.documentElement.classList.contains('rinashi-alia-delay')) return;

  const release = () => document.documentElement.classList.remove('rinashi-alia-delay');
  window.setTimeout(release, 18000);
})();
